'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var useTabs = require('./useTabs.js');

var TabPanel = function (_a) {
    var label = _a.label, children = _a.children, tabPanelClass = _a.tabPanelClass;
    var activeTab = useTabs.useTabs().activeTab;
    return activeTab === label ? (jsxRuntime.jsx("div", _tslib.__assign({ role: "tabpanel", "aria-labelledby": "tab-".concat(label), id: "panel-".concat(label), className: tabPanelClass }, { children: children }))) : null;
};

exports.TabPanel = TabPanel;
//# sourceMappingURL=TabPanel.js.map
